import React from "react";
import { BoxIcon } from "lucide-react";
interface MedallionProps {
  icon: BoxIcon;
  className?: string;
}
export function Medallion({
  icon: Icon,
  className = ''
}: MedallionProps) {
  return <span className={`inline-flex h-14 w-14 items-center justify-center rounded-full border border-accent/25 bg-accent-soft ${className}`} aria-hidden="true" data-id="element-139" data-mp="1zbqyo7zazzuw">
      <Icon className="h-6 w-6 text-accent" strokeWidth={1.5} data-id="element-140" data-mp="249aehcbngkoy" />
    </span>;
}